import { render } from "./SucessoPage.vue?vue&type=template&id=cd30ecd6&scoped=true"
import script from "./SucessoPage.vue?vue&type=script&lang=js"
export * from "./SucessoPage.vue?vue&type=script&lang=js"

import "./SucessoPage.vue?vue&type=style&index=0&id=cd30ecd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd30ecd6"]])

export default __exports__